module.exports = __webpack_public_path__ + "img/background_04.96ca2263.png";